import {
  makeStyles,
  Typography,
  Grid,
  Box,
  CircularProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TextField,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import { Delete, CheckCircle } from "@material-ui/icons";
import PartnerType from "./PartnerType";
import RoleManagement from "./RoleManagement";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import {
  fetchCollaboratorType,
  fetchNetworkType,
  updateNetworkType,
  addNetworkType,
  deleteNetworkType,
  getNetworkRoles,
} from "../../../../containers/actions/netwrokActions";
import {
  FETCH_COLLABORATOR_TYPE_LOADING,
  FETCH_NETWORK_TYPES_LOADING,
  GET_NETWORK_ROLES_LOADING,
} from "../../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@material-ui/icons/Save";
import ClearIcon from "@material-ui/icons/Clear";
import StyledButton from "../../../common/models/Button";

const useStyles = makeStyles((theme) => ({
  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
     saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
       width: "12rem",
      fontSize: "1rem",
      fontWeight: 550,
        cursor: "pointer",
                // paddingLeft:"3rem",
                // paddingRight:"3rem",
       paddingTop: "0.35rem",
                paddingBottom: "0.35rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton:{
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
       width: "12rem",
      fontSize: "1rem",
      fontWeight: 550,
        cursor: "pointer",
                // paddingLeft:"3rem",
                // paddingRight:"3rem",
       paddingTop: "0.35rem",
                paddingBottom: "0.35rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  table: {
    maxWidth: 650,
    border: "1px solid #e0e0e0",
    marginTop: 10,
  },
  smallCell: {
    padding: "4px 8px",
    fontSize: "0.875rem",
  },
  urlField: {
    marginTop: 20,
    maxWidth: 400,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    maxWidth: 650,
  },
}));

// const initialNetworkTypes = [
//     { networkType: "Biopharma Manufacturing", networkTypeID: "01",selected:"true" },
//     { networkType: "Pharma Manufacturing", networkTypeID: "02" },
//     { networkType: "Biologics Manufacturing", networkTypeID: "03" },
//     { networkType: "CGT Manufacturing", networkTypeID: "04" },
//     { networkType: "Specialty Chemicals Manufacturing", networkTypeID: "05" },
//     { networkType: "Food & Beverages Manufacturing", networkTypeID: "06" }
//   ];

const NetworkDetails = ({
  handleBack,
  handleNext,
  existingSponsorFlow,
  networkTypes,
  setNetworkTypes,
  selectedIndices,
  setSelectedIndices,
  networkURL,
  setNetworkURL,
  active,
  rowData,
  updateNetworkData,
  rowNetwork,
  setUpdateNetworkData,
  setActive,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);
  const [apiError, setApiError] = useState("");
  const [fieldError, setFieldError] = useState("");
  const updateNetworkDetails = useSelector(
    (state) => state?.network?.updateNetworkDetails
  );

  useEffect(()=>{
    if(updateNetworkDetails?.ecosystemUrl)
      setUpdateNetworkData(updateNetworkDetails)
  })

  const [waitingForUpdate, setWaitingForUpdate] = useState(false);

  // const [networkTypes, setNetworkTypes] = useState([]);
  // const [selectedIndices, setSelectedIndices] = useState(null);
  // const [networkURL, setNetworkURL] = useState("");
  // console.log("handleback",handleBack)
  const initialNetworkTypes = useSelector(
    (state) => state?.network?.networkDetails || []
  );


  let fetchViewSponsorData = useSelector(
    (state) => state?.network?.selectedSponsorDetails?.SponsorDetails || []
  );

  
  const addSponsorList = useSelector((state) => {
    return state?.network?.addSponsorDetails || [];
  });


  // console.log("networkUrl",networkURL)
  const initialNetworkTypesLoading = useSelector(
    (state) => state?.network?.fetchNetworkTypeLoading || []
  );

  const getRoles = useSelector((state) => state?.network?.getAllRoles || []);

  // useEffect(() => {
  //   dispatch({
  //     type: FETCH_NETWORK_TYPES_LOADING,
  //     payload: true,
  //   });

  //   if (addSponsorList?.data) {
  //     dispatch(fetchNetworkType(addSponsorList?.data?.ecosystemId));
  //   }
  //  if(rowData?.status === "Pending"){
  //       dispatch(fetchNetworkType(rowData?.ecosystemId));
  //   }
  // }, [addSponsorList,rowData]);

// console.log(addSponsorList, "addSponsorList")

useEffect(() => {
  dispatch({
    type: FETCH_NETWORK_TYPES_LOADING,
    payload: true,
  });

  if (existingSponsorFlow && addSponsorList?.data?.ecosystemId) {
    dispatch({
      type: FETCH_NETWORK_TYPES_LOADING,
      payload: true,
    });

      dispatch(
        fetchNetworkType(addSponsorList?.data?.ecosystemId)
      )

      return;
  }
  
  // Use a flag to ensure dispatch happens only once
  if (rowData?.status === "Pending" && rowData?.ecosystemId) {
    dispatch(fetchNetworkType(rowData.ecosystemId));
  } else if (addSponsorList?.data?.ecosystemId) {
    dispatch(fetchNetworkType(addSponsorList.data.ecosystemId));
  }
}, [addSponsorList?.data?.ecosystemId]);

  // useEffect(() => {
   


  // }, [addSponsorList?.data?.ecosystemId])



  const [partnerTypes, setPartnerTypes] = useState([]);
  const initialPartnerTypes = useSelector(
    (state) => state?.network?.partnerDetails || []
  );

  useEffect(() => {
    if (initialPartnerTypes && initialPartnerTypes?.data?.length > 0) {
      setPartnerTypes(initialPartnerTypes?.data);
    }
  }, [initialPartnerTypes]);

  useEffect(() => {
    if (
      initialNetworkTypes?.NetworkTypes &&
      initialNetworkTypes?.NetworkTypes.length > 0
    ) {
      const types = initialNetworkTypes.NetworkTypes;
      setNetworkTypes(types);

      // Find and set the active network type
      const activeType = types.find((type) => type.activated === true);
      if (activeType) {
        setActive(activeType); // replace setActive with your actual setter
      }
    }
  }, [initialNetworkTypes]);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
    setApiError("");
    setFieldError("");
  };

  const selectedItem = networkTypes[selectedIndices];
  const isAnyActivated = networkTypes?.some(item => item.activated === true);
const isItemSelected = selectedItem != null; // checks for both null & undefined
const isNetworkURLValid = networkURL && fieldError === "";
const enableSaveButton = (isAnyActivated || isItemSelected) && isNetworkURLValid;

  const sponsorRolesCount = getRoles.data?.sponsorRoles?.length || 0;
  const cmoRolesCount = getRoles.data?.cmoRoles?.length || 0;
  const rolesCount = sponsorRolesCount + cmoRolesCount;


  const handleNetworkUrlChange = (e) => {
    setNetworkURL(e.target.value);
    setApiError(""); // clear API error on change
    if (!e.target.value) {
      setFieldError("Network URL is required.");
    }
     else if (
    !/^https?:\/\//.test(e.target.value) || // Must start with http:// or https://
    !/\.(com|co)$/.test(e.target.value)     // Must end with .com or .co
  ) {
    setFieldError("Invalid URL. Must start with http:// or https:// and end with .com or .co");
  } else {
      setFieldError("");
    }
  };

  const handleSaveNext = async () => {
    setApiError(""); // clear previous API error
    // Local validation
    if (!networkURL || !isAnyActivated) {
      setFieldError(!networkURL ? "Network URL is required." : "");
      setApiError(!isAnyActivated ? "Please select a network type." : "");
      return;
    }
    setFieldError("");
    setWaitingForUpdate(true);
    const selectedItem = networkTypes[selectedIndices];
    dispatch(
      updateNetworkType({
        selectedNetwork: selectedItem?.networkType || active?.networkType,
        ecosystemTypeId: selectedItem?.ecosystem_type_id || active?.ecosystem_type_id,
        ecosystemId: addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
        organizationID: addSponsorList?.data?.organizationId || rowData?.organizationId,
        ecosystemUrl: networkURL,
      })
    );
  };



  useEffect(() => {
    if (!updateNetworkDetails) return;


    if (updateNetworkDetails.status === false) {
      setApiError(
        updateNetworkDetails.errorMessage ||
        updateNetworkDetails.errorDescription ||
        "An error occurred."
      );
      setWaitingForUpdate(false);
      return;
    }

    // Success: clear error and go to next step
    if(updateNetworkDetails.status === true){
      setApiError("");
      setWaitingForUpdate(false);
      setActiveTab((prev) => prev + 1);
    }
  }, [updateNetworkDetails]);

  const handleAddRow = () => {
    setApiError(""); // clear error on add
    const newId = (networkTypes.length + 1).toString();
    setNetworkTypes([
      ...networkTypes,
      { networkType: "", ecosystem_type_id: newId, edit: true, isNew: true,is_default: 0},
    ]);
  };

  const handleDeleteRow = async(item, index) => {
    // try {
    // const updated = [...networkTypes];
    // updated.splice(index, 1);
    // setNetworkTypes(updated);
    // setSelectedIndices((prev) => prev.filter((i) => i !== index));
    // console.log("item",item)

      if (item.isNew) {
    const updated = [...networkTypes];
    updated.splice(index, 1);
    setNetworkTypes(updated);
    return;
  }

   await dispatch(
      deleteNetworkType({
        selectedNetwork: item?.networkType,
        ecosystemTypeId: item?.ecosystem_type_id, // ecosystem_type_id
        isDeleted: "1",
      })
    );

    dispatch({
      type: FETCH_NETWORK_TYPES_LOADING,
      payload: true,
    });

  // const ecosystemIdToFetch =
  //   rowData?.status === "Pending"
  //     ? rowData?.ecosystemId
  //     : addSponsorList?.data?.ecosystemId;

  // if (ecosystemIdToFetch) {
  //   dispatch(fetchNetworkType(ecosystemIdToFetch));
  // }
  setTimeout(() => {
  if (rowData?.status === "Pending" && rowData?.ecosystemId &&
     (Array.isArray(addSponsorList) && addSponsorList.length === 0)
  ) {
    dispatch(fetchNetworkType(rowData.ecosystemId));
  } else if (addSponsorList?.data?.ecosystemId) {
    dispatch(fetchNetworkType(addSponsorList.data.ecosystemId));
  }
  },2000);
    // }
    // catch (error) {
    //   console.error("Failed to add partner details:", error);
    //   // Optionally show error UI
    // }
  };

  const handleInputChange = (index, value) => {
    const updated = [...networkTypes];
    updated[index].networkType = value;
    setNetworkTypes(updated);
    setApiError(""); // clear error on input change
  };

  const handleCheckboxChange = (index) => {
    setSelectedIndices(index);
    setApiError(""); // clear error on selection change
    const updated = networkTypes.map((item, i) => ({
      ...item,
      activated: i === index ? true : false, // only one radio can be active
    }));
    setNetworkTypes(updated);
  };

  // const isValidURL = networkURL === "https://immunoact.collabrix.io/";

  //   const handleSave = () => {
  // dispatch(addNetworkType({
  // newNetworkType: "Pharma Contract Manufacturing",
  // newNetworkTypeID: "1",
  // isDefault: false,

  // }))
  //   }

  // const handleSave = async (index) => {
  //   // const itemToSave = networkTypes[index];
  //   try {
  //     await dispatch(
  //       addNetworkType({
  //         newNetworkType: networkTypes[index].networkType,
  //         newNetworkTypeID: networkTypes[index].ecosystem_type_id,
  //         isDefault: false,
  //       })
  //     );

  //     dispatch({
  //       type: FETCH_NETWORK_TYPES_LOADING,
  //       payload: true,
  //     });

  // const ecosystemIdToFetch =
  //   rowData?.status === "Pending"
  //     ? rowData?.ecosystemId
  //     : addSponsorList?.data?.ecosystemId;

  // if (ecosystemIdToFetch) {
  //   dispatch(fetchNetworkType(ecosystemIdToFetch));
  // }
  //   } catch (error) {
  //     console.error("Failed to add partner details:", error);
  //     // Optionally show error UI
  //   }
  //   // Optionally: update 'edit' state
  //   // const updatedNetworkTypes = [...networkTypes];
  //   // updatedNetworkTypes[index].edit = false;
  //   // setNetworkTypes(updatedNetworkTypes);
  // };
    const handleSave = async (index) => {
    try {
      await dispatch(
        addNetworkType({
          newNetworkType: networkTypes[index].networkType,
          newNetworkTypeID: networkTypes[index].ecosystem_type_id,
          isDefault: false,
        })
      );

      dispatch({
        type: FETCH_NETWORK_TYPES_LOADING,
        payload: true,
      });

      // const ecosystemIdToFetch =
      //   rowData?.status === "Pending"
      //     ? rowData?.ecosystemId
      //     : addSponsorList?.data?.ecosystemId;

      // if (ecosystemIdToFetch) {
      //   dispatch(fetchNetworkType(ecosystemIdToFetch));
      // }
    setTimeout(() => {
   if (rowData?.status === "Pending" && rowData?.ecosystemId &&
     (Array.isArray(addSponsorList) && addSponsorList.length === 0)
   ) {
    dispatch(fetchNetworkType(rowData.ecosystemId));
  } else if (addSponsorList?.data?.ecosystemId) {
    dispatch(fetchNetworkType(addSponsorList.data.ecosystemId));
  }
    }, 2000);
    } catch (error) {
      console.error("Error saving network type:", error);
    }
  };



  const handleClear = (index) => {
    const updated = [...networkTypes];
    updated[index].networkType = "";
    // // updated[index].edit = false;
    setNetworkTypes(updated);
    setApiError(""); // clear error on clear
  };

  // Always show Network Type tab on mount
  useEffect(() => {
    setActiveTab(0);
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="body2" className={classes.inline}>
          Network Details
        </Typography>
        <hr className={classes.hrLine} />
      </Grid>

      <Tabs
        indicatorColor="secondary"
        textColor="secondary"
        style={{ color: "black", pointerEvents: "none", opacity: 0.7 }}
        value={activeTab}
      >
        <Tab
          style={{
            textTransform: "none",
            color: activeTab === 0 ? "#1890ff" : "black",
            cursor: "not-allowed",
            pointerEvents: "none",
          }}
          label={`Network Type (${networkTypes.length})`}
        />
        <Tab
          style={{
            textTransform: "none",
            color: activeTab === 1 ? "#1890ff" : "black",
            cursor: "not-allowed",
            pointerEvents: "none",
          }}
          label={`Partner Type (${partnerTypes.length})`}
        />
        <Tab
          style={{
            textTransform: "none",
            color: activeTab === 2 ? "#1890ff" : "black",
            cursor: "not-allowed",
            pointerEvents: "none",
          }}
          label={`Role Management (${rolesCount})`}
        />
      </Tabs>

      {activeTab === 0 && (
        <>
          <Table style={{ marginTop: "2rem" }} className={classes.table}>
            <TableHead style={{ backgroundColor: "#F9F9FC" }}>
              <TableRow>
                <TableCell className={classes.smallCell}>Selection</TableCell>
                <TableCell className={classes.smallCell}>
                  Network Type
                </TableCell>
                <TableCell align="right" className={classes.smallCell}>
                  Network Type ID
                </TableCell>
                <TableCell className={classes.smallCell}>Action</TableCell>
              </TableRow>
            </TableHead>
            {initialNetworkTypesLoading === true ? (
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={12}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            ) : networkTypes.length > 0 ? (
              <TableBody>
                {networkTypes.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell className={classes.smallCell}>
                      {/* <input
                      type="radio"
                      style={{ width: '1rem', height: '1rem' }}
                       checked={selectedIndices.includes(index)}
                      onChange={() => handleCheckboxChange(index)}
                    /> */}
                      <input
                        type="radio"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          accentColor: "#EC6535",
                        }}
                        //  checked={selectedIndices === index}
                        checked={item.activated === true}
                        onChange={() => handleCheckboxChange(index)}
                        disabled={item.isNew}
                      />
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      {item.edit ? (
                        <>
                          <Box
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "3px",
                            }}
                          >
                            <TextField
                              variant="outlined"
                              size="small"
                              value={item.networkType}
                              onChange={(e) =>  
                                handleInputChange(index, e.target.value)
                              }
                              onBlur={(e) => {
                                const trimmed = e.target.value.trim();
                                if (trimmed !== e.target.value) {
                                  handleInputChange(index, trimmed);
                                }
                              }}
onInput={(e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9\-_\s]/g, "");
}}

                            />
                            <Box
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "3px",
                              }}
                            >
                              <span title="clear">
                                <ClearIcon
                                  // onClick={() => setEdit(false)}
                                  onClick={() => handleClear(index)}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "medium",
                                  }}
                                />
                              </span>
                              <span title="save">
                                {/* <SaveIcon
                                  onClick={() => handleSave(index)} // pass index of the row
                                  // onClick={handleSave}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "medium",
                                  }}
                                /> */}
<SaveIcon
  onClick={() => {
    const trimmedValue = item.networkType.trim();
    const isDuplicate = networkTypes.some(
      (nt, i) =>
        i !== index && nt.networkType.trim().toLowerCase() === trimmedValue.toLowerCase()
    );

    if (trimmedValue !== "" && !isDuplicate) {
      handleSave(index);
    }
  }}
  style={{
    cursor:
      item.networkType.trim() === "" ||
      networkTypes.some(
        (nt, i) =>
          i !== index &&
          nt.networkType.trim().toLowerCase() === item.networkType.trim().toLowerCase()
      )
        ? "not-allowed"
        : "pointer",
    fontSize: "medium",
    color:
      item.networkType.trim() === "" ||
      networkTypes.some(
        (nt, i) =>
          i !== index &&
          nt.networkType.trim().toLowerCase() === item.networkType.trim().toLowerCase()
      )
        ? "gray"
        : "inherit",
  }}
/>

                              </span>
                            </Box>
                          </Box>
                        </>
                      ) : (
                        <Typography variant="body2">
                          {item.networkType}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="right" className={classes.smallCell}>
                      {/* {item.networkTypeID} */}
                      {item.ecosystem_type_id < 10 ? `0${item.ecosystem_type_id}` : item.ecosystem_type_id}
                      

                      {/* {item.display_id !== null && item.display_id !== undefined
                        ? item.display_id < 10
                          ? `0${item.display_id}`
                          : item.display_id
                        : item.ecosystem_type_id < 10
                        ? `0${item.ecosystem_type_id}`
                        : item.ecosystem_type_id} */}
                    </TableCell>
                    <TableCell className={classes.smallCell}>
                      {item.is_default === 0 && (
                        <IconButton
                          disableRipple
                          disableFocusRipple
                          disableTouchRipple
                          sx={{
                            backgroundColor: "transparent",
                            "&:hover": {
                              backgroundColor: "transparent",
                            },
                            "&:focus": {
                              backgroundColor: "transparent",
                            },
                          }}
                          onClick={() => handleDeleteRow(item, index)}
                        >
                          <Delete style={{ color: "red" }} />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : initialNetworkTypes?.status === false ? (
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell colSpan={10} align="center">
                  {"Something went wrong. Please contact Schrocken Support."}
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No records found
                </TableCell>
              </TableRow>
            )}
          </Table>

          {apiError && (
            <Typography style={{ color: "red", marginTop: 10 }}>
              {apiError}
            </Typography>
          )}

          <Button
            variant="outlined"
            onClick={handleAddRow}
            style={{
              marginTop: 10,
              border: "1px solid black",
              borderRadius: "4rem",
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: "550",
            }}
          >
            <AddCircleOutlineIcon />
            {"  "} Add New Network Type
          </Button>

          <div className={classes.urlField}>
            <Typography style={{ fontWeight: "bold" }}>
              Network URL
              <span style={{ fontWeight: "bold", color: "red" }}> *</span>
            </Typography>
            <TextField
              size="small"
              variant="outlined"
              value={networkURL}
              onChange={handleNetworkUrlChange}
onInput={(e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9\-_/~.:]/g, "");
}}

              fullWidth
              style={{ border: "1px solid Black" }}
            />
            {fieldError && (
              <Typography style={{ color: "red", marginTop: 5 }}>
                {fieldError}
              </Typography>
            )}
          </div>

          <div style={{ marginTop: 30 }} className={classes.actions}>
            {/* <Grid
              variant="contained"
              disabled={activeTab === 0}
              onClick={handleBack}
              style={{
                backgroundColor: "#707070",
                color: "white",
                width: "10rem",
                fontSize: "1rem",
                fontWeight: 550,
                // paddingLeft:"3rem",
                // paddingRight:"3rem",
                paddingTop: "0.5rem",
                paddingBottom: "0.5rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5rem",
                cursor: "pointer",
              }}
            >
              <ChevronLeftIcon />
              Back
            </Grid> */}
            {/* <Grid
              variant="contained"
              // onClick={handleSaveNext}
              onClick={enableSaveButton  ? handleSaveNext :null}
              style={{
                backgroundColor:"#EC6535",
                color: "white",
                width: "10rem",
                fontSize: "1rem",
                fontWeight: 550,
                cursor: "pointer",
                // paddingLeft:"3rem",
                // paddingRight:"3rem",
                paddingTop: "0.5rem",
                paddingBottom: "0.5rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5rem",
                cursor:enableSaveButton ? "pointer" :"not-allowed",
                pointerEvents: enableSaveButton ? "auto" : "none",
                opacity: enableSaveButton ? 1 : 0.6,
              }}
            >
              Save & Next
              <ChevronRightIcon />
            </Grid> */}
                  <Grid
                  className={classes.backButton}
                    onClick={handleBack}
                     disabled={activeTab === 0}
                     >
                   <ChevronLeftIcon />
                     Back
                 </Grid>
                    <Grid
                  className={classes.saveButton}
                   onClick={handleSaveNext}
                   disabled={!enableSaveButton}
                     >
                      Save & Next
                    <ChevronRightIcon />
                    </Grid>
            
          </div>
        </>
      )}

      {activeTab === 1 && (
        <PartnerType
          initialNetworkTypes={initialNetworkTypes}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
           addSponsorList={addSponsorList}
           rowData={rowData}
             updateNetworkData={updateNetworkData}
             setUpdateNetworkData={setUpdateNetworkData}
          rowNetwork={rowNetwork}
          existingSponsorFlow={existingSponsorFlow}
          networkURL={networkURL}
          selectedEcosystemTypeID = {selectedItem?.ecosystem_type_id}
        />
      )}
      {activeTab === 2 && (
        <RoleManagement
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          handleNext={handleNext}
          addSponsorList={addSponsorList}
          rowData={rowData}
          updateNetworkData={updateNetworkData}
          rowNetwork={rowNetwork}
          existingSponsorFlow={existingSponsorFlow}
          networkURL={networkURL}
        />
      )}
    </>
  );
};

export default NetworkDetails;
